import { TranslationSections } from '@/types/language';
import { SECTION_ORDER, SECTION_LABELS, humanizeKey, MULTILINE_FIELDS } from '../languages.config';

export interface EditorRow {
  section: string;
  key: string;
  label: string;
  sourceText: string;
  targetText: string;
  isEmpty: boolean;
  multiline: boolean;
  placeholders: string[];
}
export interface EditorGroup {
  section: string;
  label: string;
  rows: EditorRow[];
}

const PLACEHOLDER_RE = /\{[^}]+\}/g;

export function buildRows(source: TranslationSections, target: TranslationSections): EditorGroup[] {
  const sections = SECTION_ORDER.filter((s) => source[s]);
  // include any unexpected sections the API returns, after the known ones
  for (const s of Object.keys(source)) if (!sections.includes(s)) sections.push(s);

  return sections.map((section) => ({
    section,
    label: SECTION_LABELS[section] || humanizeKey(section),
    rows: Object.keys(source[section] || {}).map((key) => {
      const sourceText = source[section][key] ?? '';
      const targetText = target[section]?.[key] ?? '';
      return {
        section,
        key,
        label: humanizeKey(key),
        sourceText,
        targetText,
        isEmpty: !targetText,
        multiline: MULTILINE_FIELDS.has(key) || sourceText.length > 60,
        placeholders: sourceText.match(PLACEHOLDER_RE) || [],
      };
    }),
  }));
}
